import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { TranslationKeyMap } from './observation-status.i18n';

function colorForStatus(published: boolean): string {
    return published ? '#137e0f' : '#d17300';
}

@Component({
    selector: 'cmps-observation-status',
    templateUrl: './observation-status.component.html',
})
export class ObservationStatusComponent implements OnChanges {
    /** @private */ _i18n = TranslationKeyMap;
    @Input() published: boolean;
    /** @private */ _color: string;

    ngOnChanges(changes: SimpleChanges): void {
        // eslint-disable-next-line no-prototype-builtins
        if (changes.hasOwnProperty('published')) {
            this._color = colorForStatus(this.published);
        }
    }
}
